var React = require('react');

function Dribbble (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 5.5c-.3.3-2 2.5-5.8 4a30.8 30.8 0 0 1 1 2 24 24 0 0 1 7 .4c0-2.4-.8-4.6-2.3-6.4M9.6 2.1c.3.3 2.1 2.9 3.8 6 3.7-1.4 5.2-3.5 5.4-3.8a10.2 10.2 0 0 0-9.2-2.2M2 9.9c.4 0 4.6 0 9.4-1.2-1.7-3-3.5-5.6-3.8-6-2.8 1.4-5 4-5.6 7.2m2.4 9a16.3 16.3 0 0 1 8.7-7 34 34 0 0 0-.8-1.7c-5.1 1.6-10.1 1.5-10.5 1.5v.3c0 2.6 1 5 2.6 6.9M16 21.5c-.1-1-.7-4-2.2-7.8a14 14 0 0 0-8 6.4A10.2 10.2 0 0 0 16 21.5m6.1-7.9a15 15 0 0 0-6.4-.4c1.4 3.7 2 6.7 2 7.3 2.3-1.5 4-4 4.4-6.9M12 24a12 12 0 1 1 0-24 12 12 0 0 1 0 24","fill":"#EFEFEF","fillRule":"evenodd"}));
}

Dribbble.defaultProps = {"width":"24","height":"24"};

module.exports = Dribbble;

Dribbble.default = Dribbble;
